import './index.css'
import React from 'react'
import classNames from 'classnames'
import removeImg from 'assets/vault icons/deleteDateIcon.svg'
import ButtonTooltip from 'components/Common/ToolTip/ButtonTooltip'

const DocumentRemoveButton = ({ id, value, onClick, className, ...rest }) => {
  return (
    <div className={classNames('default-table-status-button-cell', className)}>
      {value === 'pending' 
      && (
        <ButtonTooltip placement={'top'} title={'Delete'} arrow>
          <img
            src={removeImg}
            height="18px"
            width="16px"
            onClick={() => onClick(id)}
            alt={'vault document delete'}
            style={{ cursor: 'pointer' }}
          />
        </ButtonTooltip>
      )}
      {value === 'uploaded' && <span className="color-success k-icon k-i-check-outline k-cursor-pointer"></span>}
      {value === 'failed' && (
        <span className="color-danger k-icon k-i-x-outline k-cursor-pointer" onClick={() => onClick(id)}></span>
      )}
    </div>
  )
}

export default DocumentRemoveButton
